import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { formatMessage } from '../../../translations/format-message';

interface Props {
  showConfirmModal: boolean;
  setShowConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
  showCompletedProcessErrorModal: boolean;
  setShowCompletedProcessErrorModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  handleStartTimer: () => void;
  handleRemoveTray: () => void;
  isLoading: boolean;
  title: string;
  message: string;
  id?: string;
  error: string;
  isBatch: boolean;
}

const ProcessInUseConfirmPopup: React.FC<Props> = (props) => {
  const handleConfirmSubmit = () => {
    props.setShowConfirmModal(false);
    props.handleStartTimer();
  };

  const handleConfirmCancel = () => {
    props.setShowConfirmModal(false);
    props.handleRemoveTray();
  };

  const handleProcessCompleted = () => {
    props.setShowCompletedProcessErrorModal(false);
    props.handleRemoveTray();
    // if(!props.isBatch){
    // }
  };

  return (
    <Modal
      show={props.showConfirmModal || props.showCompletedProcessErrorModal}
      // onHide={() => props.setShowConfirmModal(false)}
      centered
    >
      <Modal.Header>
        <Modal.Title>{formatMessage('confirmation')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {props.message}
        <div dangerouslySetInnerHTML={{ __html: props.error }} />
      </Modal.Body>

      <Modal.Footer>
        {props.showConfirmModal && (
          <>
            <Button
              variant="secondary"
              onClick={handleConfirmCancel}
            >
              {formatMessage('cancel')}
            </Button>

            <Button
              variant="primary"
              onClick={handleConfirmSubmit}
            >
              {formatMessage('continue')}
            </Button>
          </>
        )}
        {props.showCompletedProcessErrorModal && (
          <Button
            variant="primary"
            onClick={handleProcessCompleted}
          >
            {formatMessage('ok')}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ProcessInUseConfirmPopup;
